import { getPublicCompanyInfo } from '@/services/api/company.api'
import { getFopByCode } from '@/services/api/fop.api'

import { platforms } from '@/utils/constants/platforms'

export function getIconSrcByPlatform(platform) {
  return platforms[platform] && platforms[platform].logo
}

export function getDateFromObjectId(objectId) {
  return new Date(parseInt(objectId.substring(0, 8), 16) * 1000)
}

export async function getNameByCode(code) {
  const isCompanyCode = getIsCompanyCode(code)
  if (isCompanyCode) return await getCompanyName(code)

  const isFopCode = getIsFopCode(code)
  if (isFopCode) return await getFopName(code)

  return ''
}

function getIsCompanyCode(code) {
  return code.length === 8
}

function getIsFopCode(code) {
  return code.length === 10
}

async function getCompanyName(code) {
  try {
    const { data } = await getPublicCompanyInfo({ companyCode: code })
    return data.registry.shortName
  } catch (err) {
    return null
  }
}

async function getFopName(code) {
  try {
    const { data } = await getFopByCode({ code })
    return data.registry.fullName
  } catch (err) {
    return null
  }
}
